import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { UserAgreementsAcceptanceModalComponent } from './user-agreements-acceptance-modal.component';
import { DxCheckBoxModule } from 'devextreme-angular';
import { ButtonWithIndicatorModule } from 'ag-common-svc/lib/components';

@NgModule({
  declarations: [UserAgreementsAcceptanceModalComponent],
  imports: [CommonModule, SharedModule, DxCheckBoxModule, ButtonWithIndicatorModule],
  exports: [UserAgreementsAcceptanceModalComponent],
})
export class UserAgreementsAcceptanceModalModule {}
